import {
  QuestionModel,
  PopupModel,
  RandomiserDataModel,
  LockTheDoorModel,
} from "../interfaces/IContentModel";

import IconOne from "../../assets/img/popup/icon-1.png";
import PositiveFeedbackIcon from "../../assets/img/popup/visual-positive-feedback.png";
import NegativeFeedbackIcon from "../../assets/img/popup/feedback-negative.png";
import BatteryIcon from "../../assets/img/popup/visual-positive-feedback_alt.png";
import PadlockIcon from "../../assets/img/popup/padlock-icon2.png";
import PowerUpIcon from "../../assets/img/popup/powerup-icon.png";
import HelloIcon from "../../assets/img/popup/intro-icon.png";
import CloudCatcherIcon from "../../assets/img/popup/icon-colud-game.png";
import LookDoorIcon from "../../assets/img/popup/icon-intro-lock.png";
import RandomiserIcon from "../../assets/img/popup/icon-password.png";
import TapOutIcon from "../../assets/img/popup/icon-tap.png";
import EnemyHacker from "../../assets/img/popup/pop-up-enemy-avatar-hacker.png";
import EnemyTrojan from "../../assets/img/popup/pop-up-enemy-avatar-trojan.png";
import EnemyCloneG from "../../assets/img/popup/pop-up-enemy-avatar-clone-glitch.png";
import EnemyCloneN from "../../assets/img/popup/pop-up-enemy-avatar-clone-nano.png";
import EnemyCloneE from "../../assets/img/popup/pop-up-enemy-avatar-clone-encryptor.png";
import DirectionIcon from "../../assets/img/popup/direction-icon.png";
import EnemyIcon from "../../assets/img/popup/pop-up-enemy-avatar-hacker.png";

//FOR TRANSLATION EXPORT SCRIPT ONLY
// const PositiveFeedbackIcon: string= "../../assets/img/popup/visual-positive-feedback.png";
// const NegativeFeedbackIcon: string= "../../assets/img/popup/feedback-negative.png";
// const BatteryIcon: string= "../../assets/img/popup/visual-positive-feedback_alt.png";
// const PadlockIcon: string= "../../assets/img/popup/padlock-icon2.png";
// const PowerUpIcon: string= "../../assets/img/popup/powerup-icon.png";
// const HelloIcon: string= "../../assets/img/popup/intro-icon.png";
// const CloudCatcherIcon: string= "../../assets/img/popup/icon-colud-game.png";
// const LookDoorIcon: string= "../../assets/img/popup/icon-intro-lock.png";
// const RandomiserIcon: string= "../../assets/img/popup/icon-password.png";
// const TapOutIcon: string= "../../assets/img/popup/icon-tap.png";
// const EnemyHacker: string= "../../assets/img/popup/pop-up-enemy-avatar-hacker.png";
// const EnemyTrojan: string= "../../assets/img/popup/pop-up-enemy-avatar-trojan.png";
// const EnemyCloneG: string= "../../assets/img/popup/pop-up-enemy-avatar-clone-glitch.png";
// const EnemyCloneN: string= "../../assets/img/popup/pop-up-enemy-avatar-clone-nano.png";
// const EnemyCloneE: string= "../../assets/img/popup/pop-up-enemy-avatar-clone-encryptor.png";
// const DirectionIcon: string= "../../assets/img/popup/direction-icon.png";
// const EnemyIcon: string= "../../assets/img/popup/pop-up-enemy-avatar-hacker.png";

/**
 *
 * @category models
 * @export
 * @class ContentModel
 */
export default class ContentModel {
  strings: { [key: string]: string } = {
    loading: "LOADING",
    submit: "SUBMIT",
    go: "GO!",
    passStrength: "Password Strength",
    instButtLabel: "INSTRUCTIONS",
    weak: "WEAK",
    medium: "MEDIUM",
    strong: "STRONG",
    sound: "SOUND",
    voiceover: "VOICE OVER",
    resume: "RESUME",
    score: "SCORE: ",
    best: "BEST: ",
    home: "HOME",
    menu: "MENU",
    restart: "RESTART",
    start: "START",
    retry: "TRY AGAIN",
    doorOn: "DOOR LOCK\nONLINE",
    doorOff: "DOOR LOCK\nOFFLINE",
    doorLock: "LOCK IT!",
    tooLate: "TOO LATE!!\nENEMY BREACH!",
    keepRunning: "KEEP RUNNING",
    exit: "EXIT",
    skipInstructions: "SKIP INSTRUCTIONS",
    splashSubtitle: "Staying secure in cyberspace",
    unlockCharTitle: "Secret code",
    unlockCharBody:
      "To find the code, ask an adult to guide you through a cyber security mission!\n\nIf you’ve already got the code, Shh! Keep it a secret.\nJust enter it now...",
    _unlockCharVoiceOver: "CharacterSelect5",
    negativeFeedback: "Unlucky!\nYou lost some battery life",
    positiveFeedback: "Nice!\nYou saved your battery life",
    unluckyRandom: "UNLUCKY! THESE ARE FROM THE SAME CATEGORY!",
    cloudCollect: "Collect:",
  };

  glossery: {
    word: string;
    description: string;
    readonly _voiceOver?: string;
  }[] = [
    {
      word: "To hack",
      description:
        "Getting into someone else’s computer system or device without their permission, or make a device do something it was not initially designed to do. ",
      _voiceOver: "Glossary1",
    },
    {
      word: "Password",
      description:
        "A secret combination of words, letters or numbers, used for communicating with a computer to prove who you are.",
      _voiceOver: "Glossary2",
    },
    {
      word: "Password",
      description:
        "A secret combination of words, letters or numbers, used for communicating with a computer to prove who you are.",
      _voiceOver: "Glossary2",
    },
    {
      word: "Backup",
      description:
        "A copy of the information held on a device, which is stored separately from that device.",
      _voiceOver: "Glossary3",
    },
    {
      word: "Personal data",
      description:
        "Information about you held on computers, often that you wouldn’t want others, especially cybervillains, to know.",
      _voiceOver: "Glossary9",
    },
    {
      word: "Internet browser",
      description:
        "A special type of computer program that lets you use the Internet, typically websites, for example Google Chrome, Safari, Firefox, Microsoft Edge.",
      _voiceOver: "Glossary4",
    },
    {
      word: "Account",
      description:
        "An online account is when you register details with a company (such as your name and email address) so that you can use their services and keep track of your actions, anything from social media, to banking, gaming or online shopping. ",
      _voiceOver: "Glossary10",
    },
    {
      word: "Cloud",
      description:
        "When you save information in ‘the cloud’, instead of storing files and data on your own device, you are saving and accessing them online from a world-wide network of computers.",
      _voiceOver: "Glossary5",
    },
    {
      word: "Two Step Verification",
      description:
        "Also known as 2SV, MFA (multi factor authentication) and 2FA (two factor authentication). This is a security feature that gives you an extra layer of protection online and stops cybervillains getting into your accounts - even if they have your password.",
      _voiceOver: "Glossary6",
    },
    {
      word: "Spam",
      description:
        "Unwanted emails or messages that usually try to sell you something.",
      _voiceOver: "Glossary11",
    },
    {
      word: "Phishing",
      description:
        "An attempt to trick someone into giving information over the internet or by email, that would allow a cybervillain to take money and valuable information from them.",
      _voiceOver: "Glossary7",
    },
    {
      word: "Malware",
      description:
        "Malicious software is often called malware. It is a general word that means any code or content designed to have a negative impact on your device’s operating system.",
      _voiceOver: "Glossary8",
    },
  ];

  /**
   * Map of popup content, defined as an object with the key as the identifier.
   *
   * @private
   * @type {{ [key: string]: PopupModel }}
   * @memberof ContentModel
   */
  public readonly popups: { [key: string]: PopupModel } = {
    "how-to-play": {
      pages: [
        {
          _image: HelloIcon,
          title: "How to play",
          _voiceOver: "HowtoPlay1",
          body:
            "<p>You’ll be running through a virtual world known as cyberspace!</p><p>To score points, collect the glowing cyberspheres.</p><p>Use the arrow to find out more about how to play...</p>",
        },
        {
          title: "Run!​",
          _image: DirectionIcon,
          _voiceOver: "HowtoPlay2",
          body:
            "<p>Swipe left or right on your screen, or use the arrows on your keyboard to move from side to side.</p><p>To jump over obstacles, swipe up or use the up arrow on your keyboard.</p><p>Press the pause button or use the space bar to pause the game.</p>",
        },
        {
          title: "Run!​",
          _image: BatteryIcon,
          _voiceOver: "HowtoPlay3",
          body:
            "<p>Keep watching your battery power. When it runs out, the game is over.​</p><p>But don’t worry…​</p>",
        },
        {
          title: "Boost!​​",
          _image: PadlockIcon,
          _voiceOver: "HowtoPlay4",
          body:
            "<p>Collect a padlock to answer a question about staying cyber secure.</p><p>Get the question right to boost your battery power and play for longer.</p>",
        },
        {
          title: "Tip​​",
          _image: TapOutIcon,
          _voiceOver: "HowtoPlay5",
          body:
            "<p>If you see words <span class='pink'>highlighted</span>, you can click on them to find out what they mean.​</p>",
        },
        {
          title: "Avoid!​​",
          _image: EnemyIcon,
          _voiceOver: "HowtoPlay6",
          body:
            "<p>Cybervillains want to steal your power.</p><p>If you bump into them, you need to win a mini-game to keep it.</p><p>​Let’s meet the cybervillains…</p>",
        },
      ],
      closeLabel: "CONTINUE",
      _classes: "blackout",
    },

    "pause-instructions": {
      pages: [
        {
          _image: PowerUpIcon,
          title: "How to play",
          body: "<p>To score points, collect the glowing cyberspheres.</p>",
          _voiceOver: "HowtoPlay1Shorten",
        },
        {
          title: "Run!​",
          _image: DirectionIcon,
          _voiceOver: "HowtoPlay2",
          body:
            "<p>Swipe left or right on your screen, or use the arrows on your keyboard to move from side to side.</p><p>To jump over obstacles, swipe up or use the up arrow on your keyboard.</p><p>Press the pause button or use the space bar to pause the game.</p>",
        },
        {
          title: "Run!​",
          _image: BatteryIcon,
          _voiceOver: "HowtoPlay3Shorten",
          body:
            "<p>Keep watching your battery power. When it runs out, the game is over.​</p>",
        },
        {
          title: "Boost!​​",
          _image: PadlockIcon,
          _voiceOver: "HowtoPlay4",
          body:
            "<p>Collect a padlock to answer a question about staying cyber secure.</p><p>Get the question right to boost your battery power and play for longer.</p>",
        },
        {
          title: "Avoid!​​",
          _image: EnemyIcon,
          _voiceOver: "HowtoPlay6Shorten",
          body:
            "<p>Cybervillains want to steal your power.</p><p>If you bump into them, you need to win a mini-game to keep it.</p>",
        },
      ],
      closeLabel: "CLOSE",
      _classes: "blackout persistent-close",
    },

    "enemy-intros": {
      pages: [
        {
          title: "Hacker",
          body:
            "<p>I want to hack your tech and lock you out. Only the most secure cybersprinters can stop me!​</p>",
          _voiceOver: "EnemyIntros1",
        },
        {
          title: "Clone",
          _voiceOver: "EnemyIntros2",
          body:
            "<p>I want to steal your identity and pretend to be you! Are you cyber secure enough to stop me?</p>",
        },
        {
          title: "Trojan",
          _voiceOver: "EnemyIntros3",
          body:
            "<p>I want to try and trick you into giving me control of your tech. Please let me in! </p>",
        },
      ],
      _classes: "small",
      closeLabel: "CONTINUE",
    },

    "character-select": {
      pages: [
        {
          title: "My sprinter!",
          body:
            "<p>Use the arrows to choose who you want to be. Or just click PLAY.</p>",
          _voiceOver: "CharacterSelect1",
        },
        {
          title: "Play as Encryptor",
          body:
            "<p>I can run for ages! My battery power will last a long time​​.</p>",
          _voiceOver: "CharacterSelect2",
        },
        {
          title: "Play as Glitch",
          body:
            "<p>I move left and right faster than Encryptor!… But I use more battery power.</p>",
          _voiceOver: "CharacterSelect3",
        },
        {
          title: "Play as Nano",
          body:
            "<p>I’m the quickest, coolest and best. But to be me, you need a secret code.</p>",
          _voiceOver: "CharacterSelect4",
        },
      ],
      _classes: "persistent-close small",
      closeLabel: "PLAY",
    },
    "instructions-CloudCatcherScene": {
      pages: [
        {
          title: "In the clouds!​",
          _image: CloudCatcherIcon,
          body:
            "<p>Your photos, videos, apps and games could be stolen or corrupted.</p><p>Protect them by catching them in the cloud.</p>",
          _voiceOver: "CloudCatchermini-game1",
        },
        {
          _image: CloudCatcherIcon,
          body:
            "<p>At the top of the screen you’ll see how many you need to get. For example:<div class='cc-tip'></div></p><p>Hold down the arrows at the bottom to move the cloud from side to side to collect as many as you can before the bad stuff appears!​<div class='cc-bad'></div></p>",
          _voiceOver: "CloudCatchermini-game2",
        },
      ],
      _classes: "instructions blackout",
      closeLabel: "CLOSE",
    },
    "instructions-LockTheDoorScene": {
      pages: [
        {
          title: "Lock the door!​",
          _image: LookDoorIcon,
          _voiceOver: "Lockthedoormini-game1",
          body:
            "<p>An email account is the door to lots of your stuff online.</p><p>Find the right answer to two questions to close and lock the door, before a cybervillain gets in!​</p>",
        },
      ],
      _classes: "instructions blackout",
      closeLabel: "CLOSE",
    },
    "instructions-PasswordRandomiserScene": {
      pages: [
        {
          title: "Randomiser!​",
          _image: RandomiserIcon,
          _voiceOver: "Randomisermini-game1",
          body:
            "<p>Passwords keep cybervillains out.</p><p>Create a great, strong password by choosing three random words. You can click each word to see other options, try and pick the ones that are most meaningful to you.</p><p>Funny is good!​</p>",
        },
      ],
      _classes: "instructions blackout",
      closeLabel: "CLOSE",
    },
    "instructions-TapOutScene": {
      pages: [
        {
          title: "Tap out!",
          _image: TapOutIcon,
          _voiceOver: "TapOutmini-game1",
          body:
            "<p>The security defences for these devices are running out. Tap each one to update it and keep it secure.</p><p>If you don't tap in time, the device will stop working!​​</p>",
        },
      ],
      _classes: "instructions blackout",
      closeLabel: "PLAY",
    },
    "update-TapOutScene-negative": {
      pages: [
        {
          title: "Too hard?",
          _image: TapOutIcon,
          _voiceOver: "TapOutmini-game2",
          body:
            "<p>Try again, but this time look closer. If you turn on Auto Update, it will be easier.​</p><div class='tapUpdate'></div>",
        },
      ],
      _classes: "instructions blackout",
      closeLabel: "PLAY",
    },
    "update-TapOutScene-positive": {
      pages: [
        {
          title: "Well done!",
          _image: TapOutIcon,
          _voiceOver: "TapOutmini-game3",
          body:
            "<p>But that was tricky right? </p><p>Try again, but this time look closer. If you turn on Auto Updates, it will be easier.​</p><div class='tapUpdate'></div>",
        },
      ],
      _classes: "instructions blackout",
      closeLabel: "PLAY",
    },

    //CORRECT FEEDBACKS </p><p>

    "correct-feedback-CloudCatcherScene": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>You did it!</p><p>To make sure you don’t lose your stuff, even if something goes wrong, you should keep a copy. Turn on backup to keep it safe in the online ‘cloud’. Or you can save it to another device.​</p>",
          _voiceOver: "CloudCatchermini-game3",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },

    "correct-feedback-PasswordRandomiserScene": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "So random!​",
          _voiceOver: "Randomisermini-game2",
          body:
            "<p>Joining three random words creates passwords that are very hard to crack. It’s easier for you to remember if each word means something to you.</p><p>Use the arrow to find out more.​</p>",
        },
        {
          _image: PositiveFeedbackIcon,
          title: "Password tips​",
          _voiceOver: "Randomisermini-game3",
          body:
            "<p>You can also add capital letters, numbers or symbols if you need to.</p><p>Like this:</p><p>apple#dandelion8elephanT</p>",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "correct-feedback-TapOutScene": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Cool!​",
          body:
            "<p>Cybervillains always look for new ways to attack tech. </p><p>Keeping things up to date, helps keep them secure. If you use automatic updates, it’s a lot easier!​</p>",
          _voiceOver: "TapOutmini-game4",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },

    //INCORRECT FEEDBACKS </p><p>

    "incorrect-feedback-CloudCatcherScene": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>It’s easier in the real world!</p><p>To make sure you don’t lose your stuff, even if something goes wrong, you should keep a copy. Turn on backup to keep it safe in the online ‘cloud’. Or you can save it to another device.</p>",
          _voiceOver: "CloudCatchermini-game4",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },

    "incorrect-feedback-PasswordRandomiserScene": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Your password was great but to keep cybervillains out, it needs to be even more random, so avoid words from the same category. Have fun with your passwords!​</p><p>Use the arrow to find out more.​</p>",
          _voiceOver: "Randomisermini-game4",
        },
        {
          _image: NegativeFeedbackIcon,
          title: "Password tips​",
          body:
            "<p>You can also add capital letters, numbers or symbols if you need to.</p><p>Like this:</p><p>apple#dandelion8elephanT</p>",
          _voiceOver: "Randomisermini-game5",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "incorrect-feedback-TapOutScene": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Cybervillains always look for new ways to attack tech.</p><p>Keeping things up to date, helps keep them secure. If you use automatic updates, it’s a lot easier!​</p>",
          _voiceOver: "TapOutmini-game5",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },

    "enemy-hacker": {
      pages: [
        {
          title: "Oops!",
          _image: EnemyHacker,
          body:
            "<p>You ran into Hacker!</p><p>But stay cool. You can play a mini-game to protect your power.</p>​",
          _voiceOver: "Enemybumps1",
        },
      ],
      closeLabel: "OK",
      _classes: "blackout animateImg",
    },

    "enemy-trojan": {
      pages: [
        {
          title: "Oh no!​",
          _image: EnemyTrojan,
          body:
            "<p>You bumped into Trojan!​</p><p>But don’t worry. You can play a mini-game to protect your power. </p>​",
          _voiceOver: "Enemybumps2",
        },
      ],
      closeLabel: "OK",
      _classes: "blackout animateImg",
    },
    "enemy-clone-n": {
      pages: [
        {
          title: "Bump!​",
          _image: EnemyCloneN,
          body:
            "<p>Clone got in the way!​</p><p>But relax. You can play a mini-game to protect your power. ​</p>​",
          _voiceOver: "Enemybumps3",
        },
      ],
      closeLabel: "OK",
      _classes: "blackout animateImg",
    },
    "enemy-clone-g": {
      pages: [
        {
          _image: EnemyCloneG,
          title: "Bump!​",
          body:
            "<p>Clone got in the way!​</p><p>But relax. You can play a mini-game to protect your power. ​</p>​",
          _voiceOver: "Enemybumps3",
        },
      ],
      closeLabel: "OK",
      _classes: "blackout animateImg",
    },
    "enemy-clone-e": {
      pages: [
        {
          title: "Bump!​",
          _image: EnemyCloneE,
          body:
            "<p>Clone got in the way!​</p><p>But relax. You can play a mini-game to protect your power. ​</p>​",
          _voiceOver: "Enemybumps3",
        },
      ],
      closeLabel: "OK",
      _classes: "blackout animateImg",
    },
    "end-game": {
      pages: [
        {
          title: "Game over!​",
          _image: PositiveFeedbackIcon,
          body:
            "<p>But your cyber security journey is just beginning...</p><p>Have another sprint to learn more and try to beat your score.</p><p><b>When you’ve finished playing, click the arrow to let the National Cyber Security Centre know how cyber secure you’re feeling!</b></p>",
            _voiceOver: "Miscellaneous1",
        },
        {
          title: "Let us know what you think!",
          _image: PositiveFeedbackIcon,
          body:
            '<p>Fill in the CyberSprinters user survey on the next screen</p>',
            // _voiceOver: "Miscellaneous1",
        },
        {
          title: "",
          _image: PositiveFeedbackIcon,
          body:
            '<iframe width="540px" height="475px" src=https://forms.office.com/Pages/ResponsePage.aspx?id=RFeqFOHsTkei1zT0bdpkoUHNabULHGRFqEK9KoU0_XFUNkwyUDgyUzlLNDc0OU1QSlVSSVdRWUYyWS4u&embed=true frameborder="0" marginwidth="0" marginheight="0" style="border: none; max-width:100%; max-height:100vh" allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen> </iframe>',
            // _voiceOver: "Miscellaneous1",
        },
        {
          title: "What’s next?​",
          _image: PositiveFeedbackIcon,
          body:
            "<p>Check out <a href='https://www.ncsc.gov.uk/cyberfirst' target='_blank'>CyberFirst</a>.</p><p>Show your family <a href='https://www.ncsc.gov.uk/cyberaware' target='_blank'>Cyber Aware</a> and all this other useful advice on the <a href='https://www.ncsc.gov.uk/section/information-for/individuals-families' target='_blank'>National Cyber Security Centre’s website</a>.</p>​​<p>You can also ask your parent or carer to play some of <a href='https://www.ncsc.gov.uk/collection/cybersprinters/home-activities' target='_blank'>these games</a> with you at home.</p>",
          _voiceOver: "Miscellaneous2",
        },
      ],
      _classes: "persistent-close blackout",
      closeLabel: "PLAY AGAIN",
    },

    //padlock question feedbacks
    "correct-feedback-padlock_1": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>If you see messages that seem weird, or that you didn’t expect, ask an adult for help. </p><p>CyberVillains often want to get you to do things quickly – try and take a moment to think before you click.​</p>",
          _voiceOver: "Padlockquestionsfeedback1",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_1": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>If you see messages that seem weird, or that you didn’t expect, ask an adult for help. </p><p>CyberVillains often want to get you to do things quickly – try and take a moment to think before you click.</p>",
          _voiceOver: "Padlockquestionsfeedback2",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_2": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>If someone you trust sends a link that you were expecting, it’s usually safe to click it.</p><p>But if you’re not sure, always ask an adult for help.​</p>",
          _voiceOver: "Padlockquestionsfeedback3",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_2": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>If someone you trust sends a link that you were expecting, it’s usually safe to click it.</p><p>But if you’re not sure, always ask an adult for help.​</p>",
          _voiceOver: "Padlockquestionsfeedback4",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_3": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Cybervillains might try and trick you into giving them your information. In an email or via social media, it’s called ‘phishing’, by text it’s ‘smishing’ and over the phone, it goes by ‘vishing’.</p><p>If you’re ever unsure, always ask an adult for help.​</p>",
          _voiceOver: "Padlockquestionsfeedback5",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_3": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Cybervillains might try and trick you into giving them your information. In an email or via social media, it’s called ‘phishing’, by text it’s ‘smishing’ and over the phone, it goes by ‘vishing’.</p><p>If you’re ever unsure, always ask an adult for help.​</p>",
          _voiceOver: "Padlockquestionsfeedback6",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_4": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>It’s important not to use the same password more than once.</p><p>Different, unique passwords mean that if one gets stolen, your others stay safe. </p>",
          _voiceOver: "Padlockquestionsfeedback7",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_4": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>It’s important not to use the same password more than once.</p><p>Different, unique passwords mean that if one gets stolen, your others stay safe. </p>",
          _voiceOver: "Padlockquestionsfeedback8",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_5": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>A simple pattern might be easy to remember, but that makes it easy to guess.</p><p>Go for something more unique, or try using a PIN or fingerprint.​</p>",
          _voiceOver: "Padlockquestionsfeedback9",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_5": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>A simple pattern might be easy to remember, but that makes it easy to guess.</p><p>Go for something more unique, or try using a PIN or fingerprint.​</p>",
          _voiceOver: "Padlockquestionsfeedback10",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_6": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Passwords should be long and difficult for others to guess.</p><p>To create a strong password that you can remember, try joining three random words together.</p>",
          _voiceOver: "Padlockquestionsfeedback11",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_6": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Passwords should be long and difficult for others to guess.</p><p>To create a strong password that you can remember, try joining three random words together.</p>",
          _voiceOver: "Padlockquestionsfeedback12",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_7": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Don’t accept any shared photos or links from someone you don’t know.</p><p>If you’re ever unsure, always ask an adult for help.​</p>",
          _voiceOver: "Padlockquestionsfeedback13",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_7": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Don’t accept any shared photos or links from someone you don’t know.</p><p>If you’re ever unsure, always ask an adult for help.​</p>",
          _voiceOver: "Padlockquestionsfeedback14",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_8": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>When a company spots a weakness in their software they release a 'patch' to fix it. This helps to keep your information secure.</p><p>If you don’t install that patch or update, your device could be at risk to cybervillains.</p>",
          _voiceOver: "Padlockquestionsfeedback15",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_8": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>When a company spots a weakness in their software they release a 'patch' to fix it. This helps to keep your information secure.</p><p>If you don’t install that patch or update, your device could be at risk to cybervillains.</p>",
          _voiceOver: "Padlockquestionsfeedback16",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_9": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>You should delete any information on a second hand device, or perform a ‘factory reset’.</p><p>This will make sure your phone is in the best possible state before you start using it.</p>",
          _voiceOver: "Padlockquestionsfeedback17",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_9": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>You should delete any information on a second hand device, or perform a ‘factory reset’.</p><p>This will make sure your phone is in the best possible state before you start using it.</p>",
          _voiceOver: "Padlockquestionsfeedback18",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_10": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Things can get lost in the virtual world, just like in the real world.</p><p>You should do regular back ups to another device or to cloud storage in case anything is lost or stolen.</p>",
          _voiceOver: "Padlockquestionsfeedback19",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_10": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Things can get lost in the virtual world, just like in the real world.</p><p>You should do regular back ups to another device or to cloud storage in case anything is lost or stolen.</p>",
          _voiceOver: "Padlockquestionsfeedback20",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_11": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>To create a strong password that you can remember, use three random words that mean something to you.​</p>",
          _voiceOver: "Padlockquestionsfeedback21",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_11": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>To create a strong password that you can remember, use three random words that mean something to you.​</p>",
          _voiceOver: "Padlockquestionsfeedback22",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_12": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>It’s good to keep a copy of your important online information. This is often called personal data.​</p><p>On lots of devices you can do that by turning on automatic backup.</p>",
          _voiceOver: "Padlockquestionsfeedback23",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_12": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>It’s good to keep a copy of your important online information. This is often called personal data.​</p><p>On lots of devices you can do that by turning on automatic backup.</p>",
          _voiceOver: "Padlockquestionsfeedback24",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_13": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>It can be hard to remember lots of passwords.​</p><p>If you’re using your own device, you can save passwords securely using a password manager, including in your browser – so you don’t need to remember them. Ask an adult if you’re not sure.</p>",
          _voiceOver: "Padlockquestionsfeedback25",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_13": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>It can be hard to remember lots of passwords.​</p><p>If you’re using your own device, you can save passwords securely using a password manager, including in your browser – so you don’t need to remember them. Ask an adult if you’re not sure.</p>",
          _voiceOver: "Padlockquestionsfeedback26",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_14": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Cybervillains are always looking for new ways to attack your tech.​</p><p>Keeping things up to date helps to keep your tech secure.</p>",
          _voiceOver: "Padlockquestionsfeedback27",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_14": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Cybervillains are always looking for new ways to attack your tech.​</p><p>Keeping things up to date helps to keep your tech secure.</p>",
          _voiceOver: "Padlockquestionsfeedback28",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_15": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Always be careful downloading things from the internet to avoid accidentally installing malware on to your device.​</p><p>Stick to official sources and app stores, and check with an adult first.</p>",
          _voiceOver: "Padlockquestionsfeedback29",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_15": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Always be careful downloading things from the internet to avoid accidentally installing malware on to your device.​</p><p>Stick to official sources and app stores, and check with an adult first.</p>",
          _voiceOver: "Padlockquestionsfeedback30",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_16": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>An email account is the gateway to lots of your other online accounts. From there, passwords can be reset, so use a strong password for your email account that you don’t use anywhere else.</p>",
          _voiceOver: "Padlockquestionsfeedback31",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_16": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>An email account is the gateway to lots of your other online accounts. From there, passwords can be reset, so use a strong password for your email account that you don’t use anywhere else.</p>",
          _voiceOver: "Padlockquestionsfeedback32",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_17": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Always use official sources to get your games and apps, this will help you avoid accidentally downloading something dodgy.</p>",
          _voiceOver: "Padlockquestionsfeedback33",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_17": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Always use official sources to get your games and apps, this will help you avoid accidentally downloading something dodgy.</p>",
          _voiceOver: "Padlockquestionsfeedback34",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_18": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Always use official sources to get your games and apps, this will help you avoid accidentally downloading something dodgy.</p>",
          _voiceOver: "Padlockquestionsfeedback35",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_18": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!",
          body:
            "<p>Always use official sources to get your games and apps, this will help you avoid accidentally downloading something dodgy.</p>",
          _voiceOver: "Padlockquestionsfeedback36",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_19": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Two Step Verification (2SV), or 2FA/MFA, gives your online accounts an extra layer of protection, e.g. by sending a unique code or using fingerprints or face scanners. Start by switching it on for your most important accounts like email or social media.</p>",
          _voiceOver: "Padlockquestionsfeedback45",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_19": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Two Step Verification (2SV), or 2FA/MFA, gives your online accounts an extra layer of protection, e.g. by sending a unique code or using fingerprints or face scanners. Start by switching it on for your most important accounts like email or social media.</p>",
          _voiceOver: "Padlockquestionsfeedback46",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_20": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Two Step Verification (2SV), or 2FA/MFA, gives your online accounts an extra layer of protection, e.g. by sending a unique code or using fingerprints or face scanners. Start by switching it on for your most important accounts like email or social media.</p>",
          _voiceOver: "Padlockquestionsfeedback45",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_20": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Two Step Verification (2SV), or 2FA/MFA, gives your online accounts an extra layer of protection, e.g. by sending a unique code or using fingerprints or face scanners. Start by switching it on for your most important accounts like email or social media.</p>",
          _voiceOver: "Padlockquestionsfeedback46",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_21": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>By not sharing or saving your personal information online when you don’t have to, it’s easier to keep track of it and keep it safe.</p>",
          _voiceOver: "Padlockquestionsfeedback41",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_21": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>By not sharing or saving your personal information online when you don’t have to, it’s easier to keep track of it and keep it safe.</p>",
          _voiceOver: "Padlockquestionsfeedback42",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_22": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>By not sharing or saving your personal information online when you don’t have to, it’s easier to keep track of it and keep it safe.</p>",
          _voiceOver: "Padlockquestionsfeedback43",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_22": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>By not sharing or saving your personal information online when you don’t have to, it’s easier to keep track of it and keep it safe.</p>",
          _voiceOver: "Padlockquestionsfeedback44",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_23": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Two Step Verification (2SV), or 2FA/MFA, gives your online accounts an extra layer of protection, e.g. by sending a unique code or using fingerprints or face scanners. Start by switching it on for your most important accounts like email or social media.</p>",
          _voiceOver: "Padlockquestionsfeedback45",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_23": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Two Step Verification (2SV), or 2FA/MFA, gives your online accounts an extra layer of protection, e.g. by sending a unique code or using fingerprints or face scanners. Start by switching it on for your most important accounts like email or social media.</p>",
          _voiceOver: "Padlockquestionsfeedback46",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_24": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>When selling any second hand device, you should delete all information, or run a ‘factory reset’.</p><p>This will help protect your personal information.</p>",
          _voiceOver: "Padlockquestionsfeedback47",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_24": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>When selling any second hand device, you should delete all information, or run a ‘factory reset’.</p><p>This will help protect your personal information.​</p>",
          _voiceOver: "Padlockquestionsfeedback48",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_25": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Cybervillains are always looking for new ways to attack your tech.</p><p>Keeping things up to date, helps keep them secure. If you use automatic updates, it’s a lot easier!​</p>",
          _voiceOver: "Padlockquestionsfeedback49",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_25": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Cybervillains are always looking for new ways to attack your tech.</p><p>Keeping things up to date, helps keep them secure. If you use automatic updates, it’s a lot easier!​</p>",
          _voiceOver: "Padlockquestionsfeedback50",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-padlock_26": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Yay!​",
          body:
            "<p>Things can get lost in the virtual world, just like in the real world.</p><p>Backing up automatically to cloud storage, means you can get your data back if anything goes wrong.​</p>",
          _voiceOver: "Padlockquestionsfeedback51",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-padlock_26": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Things can get lost in the virtual world, just like in the real world.</p><p>Backing up automatically to cloud storage, means you can get your data back if anything goes wrong.​</p>",
          _voiceOver: "Padlockquestionsfeedback52",
        },
      ],
      closeLabel: "KEEP RUNNING",
      _classes: "feedback animateImg blackout",
    },
    // lock the door fb's
    "correct-feedback-door_0": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Phew!​",
          body:
            "<p>That’s right you can reset your password even if you’ve forgotten it completely, and get back into your profile. This is normally done using an email sent to the account you used to sign up. That might be your parent or carer’s if you don’t have your own.</p><p>You closed the door. Let’s lock it!</p>",
          _voiceOver: "Lockthedoorquestionfeedback1",
        },
      ],
      closeLabel: "LOCK IT",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-door_0": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Next time!​",
          body:
            "<p>Don’t worry you can reset your password even if you’ve forgotten it completely, and get back into your profile. This is normally done using an email sent to the account you used to sign up. That might be your parent or carer’s if you don’t have your own.</p>",
          _voiceOver: "Lockthedoorquestionfeedback2",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-door_0a": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Phew!​",
          body:
            "<p>That’s right you can reset your password even if you’ve forgotten it completely, and get back into your profile. This is normally done using an email sent to the account you used to sign up. That might be your parent or carer’s if you don’t have your own.</p><p>You closed the door. Let’s lock it!</p>",
          _voiceOver: "Lockthedoorquestionfeedback1",
        },
      ],
      closeLabel: "LOCK IT",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-door_0a": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Next time!​",
          body:
            "<p>Don’t worry you can reset your password even if you’ve forgotten it completely, and get back into your profile. This is normally done using an email sent to the account you used to sign up. That might be your parent or carer’s if you don’t have your own.</p>",
          _voiceOver: "Lockthedoorquestionfeedback2",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-door_1": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Phew!​",
          body:
            "<p>If someone gets access to a person’s email, they can use it to get into their other online accounts. So, if you have an email account, try your best to keep it secure.</p><p>You closed the door. Let’s lock it!</p>",
          _voiceOver: "Lockthedoorquestionfeedback3",
        },
      ],
      closeLabel: "LOCK IT",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-door_1": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>This is just a game.</p><p>But if someone gets access to a person’s email in real life, they could use it to get into their other online accounts. So, if you have an email account, try your best to keep it secure.</p>",
          _voiceOver: "Lockthedoorquestionfeedback4",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout",
    },
    "correct-feedback-door_2": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "You did it!​",
          body:
            "<p>People often use an email address to set up, and sign into other online accounts. So even if you’re not sending emails, you need to keep the account secure.</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback5",
        },
        {
          _image: PositiveFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback6",
        },
      ],
      closeLabel: "LOCK IT",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-door_2a": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>People often use an email address to set up, and sign into other online accounts. So even if you’re not sending emails, you need to keep the account secure.</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback7",
        },
        {
          _image: NegativeFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Vertification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback8",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-door_2": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>This is just a game.</p><p>But if someone gets access to a person’s email in real life, they could use it to get into their other online accounts. So, if you have an email account, keep it secure!</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback9",
        },
        {
          _image: NegativeFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback10",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "correct-feedback-door_3": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "Correct!​",
          body:
            "<p>An email account does help by sending many unwanted emails to a junk folder. But it can’t catch them all. So watch out for suspicious messages that ask you to click links.</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback11",
        },
        {
          _image: PositiveFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback12",
        },
      ],
      closeLabel: "LOCK IT",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "incorrect-feedback-door_3": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Not quite!​",
          body:
            "<p>An email account does help by sending unwanted emails to a junk folder. But it can’t catch them all. So watch out for suspicious messages that ask you to click links.</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback13",
        },
        {
          _image: NegativeFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback14",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "correct-feedback-door_4": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "You did it!​",
          body:
            "<p>Using one bit of information that lots of people know about is not good for security. Especially if it’s something a cybervillain can find on your social media.</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback15",
        },
        {
          _image: PositiveFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback16",
        },
      ],
      closeLabel: "LOCK IT",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "incorrect-feedback-door_4": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Using one bit of information that lots of people know about is not good for security. Especially if it’s something a cybervillain can find on your social media.</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback17",
        },
        {
          _image: NegativeFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback18",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "correct-feedback-door_5": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "You did it!​",
          body:
            "<p>Phishing is a scam cybervillains use to steal your information, usually by email, text message, phone call or social media. If something doesn’t feel right, ask an adult you trust.</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback19",
        },
        {
          _image: PositiveFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback20",
        },
      ],
      closeLabel: "LOCK IT",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "incorrect-feedback-door_5": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Phishing is a scam cybervillains use to steal your information, usually by email, text message, phone call or social media. If something doesn’t feel right, ask an adult you trust.</p><p>Use the arrow to find out more.</p>",
          _voiceOver: "Lockthedoorquestionfeedback21",
        },
        {
          _image: NegativeFeedbackIcon,
          title: "Keep out!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback22",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout persistent-close",
    },
    "correct-feedback-door_6": {
      pages: [
        {
          _image: PositiveFeedbackIcon,
          title: "You did it!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback23",
        },
      ],
      closeLabel: "LOCK IT",
      _classes: "feedback animateImg blackout",
    },
    "incorrect-feedback-door_6": {
      pages: [
        {
          _image: NegativeFeedbackIcon,
          title: "Never mind!​",
          body:
            "<p>Passwords make it difficult for cybervillains to get into an email account. To make it even more secure, people use extra things like secret codes sent by text message or email. This is usually called Two Step Verification (2SV).</p>",
          _voiceOver: "Lockthedoorquestionfeedback24",
        },
      ],
      closeLabel: "TRY AGAIN",
      _classes: "feedback animateImg blackout",
    },
  };

  public readonly questionCategories: { [key: string]: string } = {
    cat1: "Categorey One",
  };

  public readonly questions: QuestionModel[] = [];
  public readonly mainQuestionsEasy: QuestionModel[] = [ // BANK 1
    {
      question:
        "A message pops up while you’re playing an online game: “You have 2 minutes to pay £5 for extra points or your session will end”.\n\nDo it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_1",
      negFB: "incorrect-feedback-padlock_1",
      _voiceOver: "Padlockquestions1",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "A message pops up while you’re looking at a website: “You’ve won a new phone. Click here to get your prize”.\n\nClick it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_1",
      negFB: "incorrect-feedback-padlock_1",
      _voiceOver: "Padlockquestions2",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "You get a message from someone you don’t know with a link to a funny animal video.\n\nClick it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_1",
      negFB: "incorrect-feedback-padlock_1",
      _voiceOver: "Padlockquestions3",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "Your teacher sends you a link to a homework website. They told you they would send it.\n\nOpen it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_2",
      negFB: "incorrect-feedback-padlock_2",
      _voiceOver: "Padlockquestions4",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "Your friend sends you a message to show you the selfie you took earlier.\n\nReply?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_2",
      negFB: "incorrect-feedback-padlock_2",
      _voiceOver: "Padlockquestions5",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "Phishing, Smishing and Vishing. These odd sounding words all relate to scams cybervillains might try.\n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_3",
      negFB: "incorrect-feedback-padlock_3",
      _voiceOver: "Padlockquestions6",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "You get a message asking you to click a link and re-enter your TikTok login details.\n\nClick it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_3",
      negFB: "incorrect-feedback-padlock_3",
      _voiceOver: "Padlockquestions7",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "You’re struggling to think of a password for your Snapchat account.\n\nUse the same one as your Instagram account?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_4",
      negFB: "incorrect-feedback-padlock_4",
      _voiceOver: "Padlockquestions8",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
  ];
  public readonly mainQuestionsMedium: QuestionModel[] = [  // BANK 3
    {
      question:
        "You’re setting a pattern to unlock your new phone. An ‘L’ shape is a safe choice.\n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_5",
      negFB: "incorrect-feedback-padlock_5",
      _voiceOver: "Padlockquestions9",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "You’re setting up a new phone, it’s default password is set as “123456”.\n\nChange it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_6",
      negFB: "incorrect-feedback-padlock_6",
      _voiceOver: "Padlockquestions10",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "You ask an adult for the wifi password at home, they tell you it’s your pet’s name. \n\nShould they change it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_6",
      negFB: "incorrect-feedback-padlock_6",
      _voiceOver: "Padlockquestions11",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "A message pops up on your phone saying someone you don’t know wants to share a photo with you over Bluetooth.\n\nAccept?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_7",
      negFB: "incorrect-feedback-padlock_7",
      _voiceOver: "Padlockquestions12",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "Devices with out of date software and apps are more at risk from cybervillains.\n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_8",
      negFB: "incorrect-feedback-padlock_8",
      _voiceOver: "Padlockquestions14",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "A patch is when companies fix weaknesses in their software.\n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_8",
      negFB: "incorrect-feedback-padlock_8",
      _voiceOver: "Padlockquestions15",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "You should factory reset a new second-hand phone before using it. \n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_9",
      negFB: "incorrect-feedback-padlock_9",
      _voiceOver: "Padlockquestions16",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "You have all your holiday photos saved on your phone.\n\nMake a copy?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_10",
      negFB: "incorrect-feedback-padlock_10",
      _voiceOver: "Padlockquestions17",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "You only need to make a back up when your phone reminds you to.\n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_10",
      negFB: "incorrect-feedback-padlock_10",
      _voiceOver: "Padlockquestions18",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "When shopping online, only fill in the information about yourself that you absolutely have to (usually marked with an asterisk*)?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_21",
      negFB: "incorrect-feedback-padlock_21",
      _voiceOver: "Padlockquestions31",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "You’re buying something from an online store you’ve not used before. The store asks if they can save the payment details for a quicker check-out next time.\nAccept?​",
      _category: "cat1",
      posFB: "correct-feedback-padlock_22",
      negFB: "incorrect-feedback-padlock_22",
      _voiceOver: "Padlockquestions32",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "Two-step verification (2SV) adds security by asking you for a second piece of information to prove it’s you?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_23",
      negFB: "incorrect-feedback-padlock_23",
      _voiceOver: "Padlockquestions33",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "When getting rid of an old games console, it’s important to delete all your data and personal details?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_24",
      negFB: "incorrect-feedback-padlock_24",
      _voiceOver: "Padlockquestions34",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "You’re setting up a new device, it asks if you want automatic updates switched on?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_25",
      negFB: "incorrect-feedback-padlock_25",
      _voiceOver: "Padlockquestions35",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "You’re setting up a new app, it asks if you want automatic backup switched on?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_26",
      negFB: "incorrect-feedback-padlock_26",
      _voiceOver: "Padlockquestions36",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
  ];
  public readonly mainQuestionsHard: QuestionModel[] = [  // BANK 2
    {
      question:
        "Joining three random words is a great way to create a secure password.\n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_11",
      negFB: "incorrect-feedback-padlock_11",
      _voiceOver: "Padlockquestions19",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "An adult you trust tells you to click a button on your device to back up your data.\n\nDo it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_12",
      negFB: "incorrect-feedback-padlock_12",
      _voiceOver: "Padlockquestions20",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "Your internet browser asks you to save your password for a website.\n\nAccept?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_13",
      negFB: "incorrect-feedback-padlock_13",
      _voiceOver: "Padlockquestions21",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "To remember different passwords, you can save them to your browser to keep them safe. \n\nAgree? ",
      _category: "cat1",
      posFB: "correct-feedback-padlock_13",
      negFB: "incorrect-feedback-padlock_13",
      _voiceOver: "Padlockquestions22",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question: "Your phone tells you it’s time to do an update.\n\nUpdate?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_14",
      negFB: "incorrect-feedback-padlock_14",
      _voiceOver: "Padlockquestions23",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question: "Downloading videos and games can’t do any harm.\n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_15",
      negFB: "incorrect-feedback-padlock_15",
      _voiceOver: "Padlockquestions24",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "A message pops up saying “you have a virus, download this software to fix it”.\n\nDownload it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_15",
      negFB: "incorrect-feedback-padlock_15",
      _voiceOver: "Padlockquestions25",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "It’s really important to protect your email account, even if you hardly ever send emails.\n\nAgree?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_16",
      negFB: "incorrect-feedback-padlock_16",
      _voiceOver: "Padlockquestions26",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "A gamer you’ve met and played with online sends you a link for an upgrade.\nClick it?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_17",
      negFB: "incorrect-feedback-padlock_17",
      _voiceOver: "Padlockquestions27",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "You get a DM (direct message) with a link to a new game, from someone who says they’ve been playing it with your friend.\nClick it?​",
      _category: "cat1",
      posFB: "correct-feedback-padlock_18",
      negFB: "incorrect-feedback-padlock_18",
      _voiceOver: "Padlockquestions28",
      answers: [
        {
          text: "YES",
          _correct: false,
        },
        {
          text: "NO",
          _correct: true,
        },
      ],
    },
    {
      question:
        "Two step verification (2SV), can also be referred to as two-factor authentication (2FA) or multi-factor authentication (MFA)?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_19",
      negFB: "incorrect-feedback-padlock_19",
      _voiceOver: "Padlockquestions29",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
    {
      question:
        "Two-step verification (2SV) is an extra layer of security on top of your password?",
      _category: "cat1",
      posFB: "correct-feedback-padlock_20",
      negFB: "incorrect-feedback-padlock_20",
      _voiceOver: "Padlockquestions30",
      answers: [
        {
          text: "YES",
          _correct: true,
        },
        {
          text: "NO",
          _correct: false,
        },
      ],
    },
  ];

  public readonly lockTheDoorDataModel: LockTheDoorModel = {
    introPopup: "",
    negativeFB: "",
    positiveFB: "",
    easyQuestions: [
      {
        question:
          "You’ve forgotten the password for a social media account. You'll have to set up a new profile. Agree?​",
        _category: "cat1",
        posFB: "correct-feedback-door_0a",
        negFB: "incorrect-feedback-door_0a",
        _voiceOver: "Lockthedoorquestions1",
        answers: [
          {
            text: "YES",
            _correct: false,
          },
          {
            text: "NO",
            _correct: true,
          },
        ],
      },
      {
        question:
          "Your best friend wants to know your email password. Share it?",
        _category: "cat1",
        posFB: "correct-feedback-door_1",
        negFB: "incorrect-feedback-door_1",
        _voiceOver: "Lockthedoorquestions2",
        answers: [
          {
            text: "YES",
            _correct: false,
          },
          {
            text: "NO",
            _correct: true,
          },
        ],
      },
      {
        question:
          "You often need an email address to sign up to games and apps. You might use your parent or carer’s email, if you haven’t got one. True?",
        _category: "cat1",
        posFB: "correct-feedback-door_2",
        negFB: "incorrect-feedback-door_2a",
        _voiceOver: "Lockthedoorquestions3",
        answers: [
          {
            text: "YES",
            _correct: true,
          },
          {
            text: "NO",
            _correct: false,
          },
        ],
      },
      {
        question:
          "Email accounts often hold important information, like what someone has paid for online and other accounts they’ve signed up for. True?​",
        _category: "cat1",
        posFB: "correct-feedback-door_1",
        negFB: "incorrect-feedback-door_1",
        _voiceOver: "Lockthedoorquestions4",
        answers: [
          {
            text: "YES",
            _correct: true,
          },
          {
            text: "NO",
            _correct: false,
          },
        ],
      },
      {
        question:
          "If a cybervillain gets into someone’s email account, they could pretend to be them online. True?​",
        _category: "cat1",
        posFB: "correct-feedback-door_1",
        negFB: "incorrect-feedback-door_1",
        _voiceOver: "Lockthedoorquestions5",
        answers: [
          {
            text: "YES",
            _correct: true,
          },
          {
            text: "NO",
            _correct: false,
          },
        ],
      },
    ],
    medQuestions: [
      {
        question:
          "People often use an email address to access important websites, such as online shopping or social media. True?",
        _category: "cat1",
        posFB: "correct-feedback-door_2",
        negFB: "incorrect-feedback-door_2",
        _voiceOver: "Lockthedoorquestions6",
        answers: [
          {
            text: "YES",
            _correct: true,
          },
          {
            text: "NO",
            _correct: false,
          },
        ],
      },
      {
        question:
          "If a cybervillain gets into someone’s email account, they can only change the password to that account, so it won’t do much harm. True?",
        _category: "cat1",
        posFB: "correct-feedback-door_2",
        negFB: "incorrect-feedback-door_2",
        _voiceOver: "Lockthedoorquestions7",
        answers: [
          {
            text: "YES",
            _correct: false,
          },
          {
            text: "NO",
            _correct: true,
          },
        ],
      },
      {
        question:
          "An email account automatically filters out all suspicious or dodgy emails. True?",
        _category: "cat1",
        posFB: "correct-feedback-door_3",
        negFB: "incorrect-feedback-door_3",
        _voiceOver: "Lockthedoorquestions8",
        answers: [
          {
            text: "YES",
            _correct: false,
          },
          {
            text: "NO",
            _correct: true,
          },
        ],
      },
      {
        question:
          "Your best friend’s name would make a good strong password. Agree?",
        _category: "cat1",
        posFB: "correct-feedback-door_4",
        negFB: "incorrect-feedback-door_4",
        _voiceOver: "Lockthedoorquestions9",
        answers: [
          {
            text: "YES",
            _correct: false,
          },
          {
            text: "NO",
            _correct: true,
          },
        ],
      },
      {
        question:
          "If an unexpected message tries to get someone to click a link and give away personal information. This is called Phishing. True?",
        posFB: "correct-feedback-door_5",
        negFB: "incorrect-feedback-door_5",
        _voiceOver: "Lockthedoorquestions10",
        _category: "cat1",
        answers: [
          {
            text: "YES",
            _correct: true,
          },
          {
            text: "NO",
            _correct: false,
          },
        ],
      },
      {
        question:
          "Sometimes, you need more than just a password to get into an email account. True?",
        _category: "cat1",
        posFB: "correct-feedback-door_6",
        negFB: "incorrect-feedback-door_6",
        _voiceOver: "Lockthedoorquestions11",
        answers: [
          {
            text: "YES",
            _correct: true,
          },
          {
            text: "NO",
            _correct: false,
          },
        ],
      },
    ],
    hardQuestions: [],
  };

  public readonly randomiserDataModel: RandomiserDataModel = {
    pageTitle: "Randomiser",

    questionItems: [
      {
        text: "Cucumber",
        category: 0,
      },
      {
        text: "Potato",
        category: 0,
      },
      {
        text: "Daisy",
        category: 1,
      },
      {
        text: "Dandelion",
        category: 1,
      },
      {
        text: "Broccoli",
        category: 0,
      },
      {
        text: "Yellow",
        category: 2,
      },
      {
        text: "Blue",
        category: 2,
      },
      {
        text: "Green",
        category: 2,
      },
      {
        text: "Buttercup",
        category: 1,
      },
      {
        text: "Hedgehog",
        category: 4,
      },
      {
        text: "Apple",
        category: 5,
      },
      {
        text: "Dog",
        category: 4,
      },
      {
        text: "Banana",
        category: 5,
      },
      {
        text: "Forest",
        category: 3,
      },
      {
        text: "Milk",
        category: 6,
      },
      {
        text: "Pineapple",
        category: 5,
      },
      {
        text: "Elephant",
        category: 4,
      },
      {
        text: "Juice",
        category: 6,
      },
      {
        text: "Water",
        category: 6,
      },
      {
        text: "Running",
        category: 7,
      },
      {
        text: "Mountains",
        category: 3,
      },
      {
        text: "Surfing",
        category: 7,
      },
      {
        text: "Beach",
        category: 3,
      },
      {
        text: "Tennis",
        category: 7,
      },
    ],
  };
}
